var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeforeEprQa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 130,
    viewBox: "0 0 70 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M2.05371 0.470837C34.2056 -0.484241 55.0644 -0.968433 63.6348 9.05635C74.8174 28.1321 67.3705 34.4314 68.8643 72.2672C70.1908 107.819 66.5559 128.146 47.311 129.51C45.3181 129.501 26.3068 129.424 0.367188 129.318",
    fill: "#00376F"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.68652 0.481422C3.44011 0.428566 5.90274 0.357032 8.85449 0.281044C10.7469 0.232276 13.218 0.168678 15.5049 0.123573C20.5234 0.0245738 24.8294 -0.060326 30.0347 0.0451427C32.3803 0.0926891 35.6881 0.19474 39.6772 0.437477C39.0617 43.4526 38.4466 86.4677 37.8311 129.483C25.2208 129.431 12.6103 129.38 0 129.328C0.562153 86.3792 1.12437 43.4303 1.68652 0.481422Z",
    fill: "url(#paint0_linear_1181_32)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1181_32",
    x1: 39.206,
    y1: 64.8538,
    x2: 0.473769,
    y2: 64.5704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeEprQa);
export default __webpack_public_path__ + "static/media/before-EPR-QA.28c3168e2e33b995777db98c8fea20e4.svg";
export { ForwardRef as ReactComponent };